import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import Breadcrumbs from '../../src/components/Breadcrumbs';
import '../styles/PacDebt.css';

const Home = () => {
  const navigate = useNavigate();

  const dashboardItems = [
    {
      title: 'Scrub Process',
      description: 'Upload and process CSV files for debt scrubbing',
      icon: '📊',
      path: '/Credit-Upload',
      disabled: false,
      hidden: false
    },
    {
      title: 'Negotiator\'s Worklist',
      description: 'Manage and review negotiator work items',
      icon: '📋',
      path: '/Negotiator-Worklist',
      disabled: false,
      hidden: false
    },
    {
      title: 'Summons Process',
      description: 'Upload and process CSV files for updating fields connected to legal',
      icon: '⚖️',
      path: '/Summons',
      disabled: false,
      hidden: false
    },
    {
      title: 'Debt Settlement Calculator',
      description: 'FiHInancial calculations and tools for Negotiations',
      icon: '🧮',
      path: '/Debt-Settlement-Calculator',
      disabled: true,
      hidden: true
    },
    {
      title: 'EPF Rebalancer',
      description: 'Financial calculations and tools for Negotiations',
      icon: '🧮',
      path: '/EPF-Rebalancer',
      disabled: false,
      hidden: false
    },
    {
      title: 'SIF Offer Draft Calculator',
      description: 'Fee calculation tool for Negotiations',
      icon: '🔢',
      path: '/SIF-Offer-Simulator',
      disabled: false,
      hidden: false
    },
    {
      title: 'Production Pulse',
      description: 'Tracker Tool for Negotiations',
      icon: '📊',
      path: '/Product-Pulse',
      disabled: false,
      hidden: false
    },
    {
      title: 'Settlement Vault',
      description: 'Tradeline View for Negotiations',
      icon: '💼',
      path: '/Settlement-Vault',
      disabled: false,
      hidden: false
    },
    {
      title: 'Payment Change Calculator',
      description: 'Deposit/Debit recalculation tool with forecasting for Client Care',
      icon: '📈',
      path: '/Payment-Change-Calculator',
      disabled: false,
      hidden: false
    },
    {
      title: 'Payment Change History',
      description: 'Change History Tool for Client Care Supervisors',
      icon: '⏳',
      path: '/Payment-Change-History',
      disabled: false,
      hidden: false
    },

  ];

  return (
    <StyledContainer>
        <div className="app-container">
         <div className="container">
          
            <Header>
                <h1>Dashboard</h1>
                <p>Welcome to the PDR Core Application</p>
            </Header>
            
            <DashboardGrid>
                {dashboardItems.filter(item => !item.hidden).map((item, index) => (
                <Tooltip key={index} title={item.disabled ? "Under maintenance" : ""}>
                <DashboardCard
                    onClick={!item.disabled ? () => navigate(item.path) : undefined}
                    disabled={item.disabled}
                >
                    <CardIcon>{item.icon}</CardIcon>
                    <CardContent>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    </CardContent>
                    <CardArrow>→</CardArrow>
                </DashboardCard>
                </Tooltip>
                ))}
            </DashboardGrid>
            <div className='custom-footer'>
                <label>© 2025 Pacific Debt Relief. All rights reserved. </label>
                <span className='badge'>Core App 3.40</span>
            </div>
          </div> 
      </div>
    </StyledContainer>
  );
};

export default Home;

const StyledContainer = styled.div`
  padding: 20px;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    color: #fffff;
    font-size: 2.5rem;
    margin-bottom: 8px;
  }
  
  p {
    color: #fffff;
    font-size: 1.1rem;
  }
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const DashboardCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    ${props => !props.disabled && `
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      border-color: #3b82f6;
    `}
  }
`;

const CardIcon = styled.div`
  font-size: 2.5rem;
  flex-shrink: 0;
`;

const CardContent = styled.div`
  flex: 1;
  
  h3 {
    color: #111827;
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  p {
    color: #6b7280;
    font-size: 0.9rem;
    line-height: 1.4;
  }
`;

const CardArrow = styled.div`
  color: #9ca3af;
  font-size: 1.5rem;
  font-weight: bold;
`;
